module.exports = __webpack_public_path__ + "img/licence-1.png";